import src from "IMAGE";
export default { src, width: 326, height: 326, blurWidth: 0, blurHeight: 0};
